<template>
  <main class="policy-page section">
    <div class="container">
      <div class="section-header">
        <h1>Polityka prywatności i cookies</h1>
        <div class="section-line"></div>
        <p>Informacja o przetwarzaniu danych osobowych oraz używaniu plików cookies na stronie VI-GAS. Przetwarzanie odbywa się zgodnie z RODO.</p>
      </div>

      <section class="policy-block">
        <h2>1. Administrator danych</h2>
        <p>Administratorem danych jest Firma Vi-Gas Aleksandra Tatula.
        Adres siedziby: ul. Gliwicka 3, 03-608 Warszawa.
        NIP: 5243025480. REGON: 540429162.
        W sprawach dotyczących danych osobowych prosimy o kontakt pod adresem e-mail: kontakt@vi-gas.pl lub telefonicznie: +48 570 422 020.</p>
      </section>

      <section class="policy-block">
        <h2>2. Jakie dane przetwarzamy</h2>
        <p>W formularzu kontaktowym przetwarzamy dane podane dobrowolnie przez użytkownika: adres instalacji, typ urządzenia, numer telefonu i opis zgłoszenia.</p>
      </section>

      <section class="policy-block">
        <h2>3. Cel przetwarzania danych</h2>
        <p>Dane są przetwarzane w celu obsługi zgłoszenia serwisowego, kontaktu zwrotnego oraz realizacji usługi. Podstawą prawną przetwarzania jest art. 6 ust. 1 lit. b RODO, czyli niezbędność do wykonania umowy lub podjęcia działań na żądanie osoby, która chce skorzystać z usługi.</p>
      </section>

      <section class="policy-block">
        <h2>4. Pliki cookies</h2>
        <p>Na stronie wykorzystujemy dwa rodzaje cookies:</p>
        <ul>
          <li>niezbędne cookies, potrzebne do prawidłowego działania serwisu,</li>
          <li>opcjonalne cookies analityczne, które zbieramy tylko po wyrażeniu zgody w banerze cookies.</li>
        </ul>
        <p>Zgoda na cookies analityczne jest dobrowolna. Wybór jest zapisywany w pamięci przeglądarki a dostęp do preferencji można zmienić usuwając dane cookies lub lokalne ustawienia przeglądarki.</p>
      </section>

      <section class="policy-block">
        <h2>5. Okres przechowywania danych</h2>
        <p>Dane są przechowywane przez czas niezbędny do obsługi zgłoszenia oraz zgodnie z obowiązującymi przepisami prawa.</p>
      </section>

      <section class="policy-block">
        <h2>6. Prawa użytkownika</h2>
        <p>Użytkownik ma prawo dostępu do danych, ich poprawiania, usunięcia, ograniczenia przetwarzania oraz wniesienia sprzeciwu. W każdej chwili może zgłosić żądanie realizacji swoich praw, kontaktując się pod adresem kontakt@vi-gas.pl.</p>
      </section>

      <section class="policy-block">
        <h2>7. Prawo do cofnięcia zgody</h2>
        <p>W przypadku, gdy przetwarzanie odbywa się, na podstawie zgody, użytkownik ma prawo w dowolnym momencie cofnąć zgodę. Cofnięcie zgody nie wpływa na zgodność z prawem przetwarzania przed jej cofnięciem. Aby cofnąć zgodę na cookies, użytkownik może skorzystać z linku „Zarządzaj zgodami” w stopce strony lub usunąć lokalne dane przeglądarki.</p>
      </section>

      <section class="policy-block">
        <h2>8. Archiwizacja zgód</h2>
        <p>Dokumentujemy udzielone zgody (data i godzina, zakres zgody, informacje pomocnicze takie jak user agent) w pamięci przeglądarki użytkownika. W razie potrzeby administracja może zażądać dostępu do zapisów zgód w celu wykazania zgodności z RODO. Zgody przechowujemy przez czas niezbędny oraz zgodnie z obowiązującymi przepisami.</p>
      </section>

      <p class="policy-date">Data aktualizacji: 02.06.2026</p>
    </div>
  </main>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage'
}
</script>

<style lang="scss" scoped>
.policy-page {
  background: #f8f9fa;
  min-height: calc(100vh - 80px);
}

.policy-block {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 18px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);

  h2 {
    margin-bottom: 10px;
    color: #1e3c72;
    font-size: 1.3rem;
  }

  p {
    color: #444;
    line-height: 1.7;
  }
}

.policy-date {
  margin-top: 24px;
  color: #666;
  text-align: right;
}
</style>
